import {
  CancelDocumentsUploadProcessDocument,
  CancelDocumentsUploadProcessMutation,
  CancelDocumentsUploadProcessMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCancelUploadProcess = () => {
  const [mutate, { loading }] = useMutation(CancelDocumentsUploadProcessDocument, {
    extractorFn: (data: CancelDocumentsUploadProcessMutation) =>
      data.documentsMutations.cancelDocumentsUploadProcess,
  })

  const cancelUploadProcess = (variables: CancelDocumentsUploadProcessMutationVariables) => {
    return mutate({
      variables,
    })
  }

  return { cancelUploadProcess, loading }
}
